export default __webpack_public_path__ + "static/media/education.d648962d.svg";